"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var useWindowData = function useWindowData(key) {
  var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  var ref = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var interval = setInterval(function () {
      if (window[key]) {
        ref.current = window[key];
        setLoaded(true);
        clearInterval(interval);
      }
    }, 500);
    return function () {
      return clearInterval(interval);
    };
  }, [setLoaded, key, ref]);
  return [loaded, ref];
};

var _default = useWindowData;
exports["default"] = _default;